import { render } from "./chatStoreList.vue?vue&type=template&id=cf0510b2"
import script from "./chatStoreList.vue?vue&type=script&lang=js"
export * from "./chatStoreList.vue?vue&type=script&lang=js"

import "./chatStoreList.vue?vue&type=style&index=0&id=cf0510b2&lang=scss"

import exportComponent from "C:\\Users\\30822\\Desktop\\LQ\\git\\度才子\\supplier_pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__